module.exports = __webpack_public_path__ + "static/media/Profile.e78fcfb9.svg";